export default __webpack_public_path__ + "static/banner-ES-web-2a1de0dab431cde2d3e177ea497422ad.png";